import React from 'react';
import { Form, Header, Modal } from 'semantic-ui-react';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';

type Props = {
    correos: ReadonlyArray<{ año: number; correo: string }>;
    titulo?: string;
    alCerrar(): void;
};

export const ModalCorreos: React.FunctionComponent<Props> = props => {
    const { alCerrar, correos, titulo = 'Correos electrónicos', children } = props;

    const correos2019 = correos.filter(x => x.año === 2019).map(x => x.correo);
    const correos2020 = correos.filter(x => x.año === 2020).map(x => x.correo);
    const correos2021 = correos.filter(x => x.año === 2021).map(x => x.correo);
    const correos2022 = correos.filter(x => x.año === 2022).map(x => x.correo);
    const correos2023 = correos.filter(x => x.año === 2023).map(x => x.correo);
    const correos2024 = correos.filter(x => x.año === 2024).map(x => x.correo);
    const correos2025 = correos.filter(x => x.año === 2025).map(x => x.correo);

    return (
        <ModalEnfocable open onClose={alCerrar} closeIcon>
            <Header icon='mail' content={titulo} />

            <Modal.Content>
                <Form>
                    <Form.TextArea
                        label={`2019 (${correos2019.length} correos)`}
                        rows='5'
                        autoFocus
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2019.join(', ')}
                    />

                    <Form.TextArea
                        label={`2020 (${correos2020.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2020.join(', ')}
                    />

                    <Form.TextArea
                        label={`2021 (${correos2021.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2021.join(', ')}
                    />

                    <Form.TextArea
                        label={`2022 (${correos2022.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2022.join(', ')}
                    />

                    <Form.TextArea
                        label={`2023 (${correos2023.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2023.join(', ')}
                    />

                    <Form.TextArea
                        label={`2024 (${correos2024.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2024.join(', ')}
                    />

                    <Form.TextArea
                        label={`2025 (${correos2025.length} correos)`}
                        rows='5'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correos2025.join(', ')}
                    />
                </Form>

                <div style={{ marginTop: '14px' }}>
                    <p>
                        Puede copiar y pegar estos correos directamente en su sistema de correos
                        electrónicos.
                    </p>
                    {children}
                </div>
            </Modal.Content>
        </ModalEnfocable>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/ModalCorreos.tsx